module.exports = __webpack_public_path__ + "img/cooperate_qy_05@2x.c7aebe28.png";